export default "__VITE_ASSET__CIb2yD6V__"